import { injectable } from 'inversify';

import { User } from '@project44/ui-utils';
import {
  Enums,
  TenantModels,
  UIDtoFactory,
} from '@project44-models/iam-gateway';

@injectable()
export class UserPrincipalAdapter {
  toTenant(user: User): TenantModels.TenantViewModel {
    return UIDtoFactory.create(Enums.UiDtoFactoryEnum.TENANT, {
      // @ts-expect-error type mismatch: string[] !== CarrierNetworkRolesEnum[]
      carrierNetworkRoles: user.tenantCarrierNetworkRoles,
      tenantId: String(user.tenantId),
      contactEmail: user.username,
      name: user.companyName,
      tenantUuid: user.tenantUuid,
    }).toSerializedModel();
  }
}
